import fallbackDark from "./fallback-game.svg";
import fallbackLight from "./fallback-game-light.svg";

/**
 * Theme-aware game thumbnail fallback (image missing / load error).
 * Reads current `data-theme` so light mode does not show the dark navy art.
 */
export function getFallbackGameImage(theme) {
  const resolved =
    theme ??
    (typeof document !== "undefined" ? document.documentElement.getAttribute("data-theme") : null);
  return resolved === "light" ? fallbackLight : fallbackDark;
}

export {fallbackDark, fallbackLight};
